<!-- 员工管理 staff-->
<template>
  <div class="staff">
    <div class="form_header">
      <el-form ref="form" :model="userform" label-width="80px">
        <div class="form_list">
          <el-form-item label="角色：">
            <el-select v-model="userform.role_id" placeholder="请选择角色">
              <el-option v-for="item in roledatas" :key="item.role_id" :label="item.title" :value="item.role_id"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn_box">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button @click="nosub">取消</el-button>
          </div>
        </div>
      </el-form>
      <div>
        <!-- <el-button type="primary" icon="el-icon-upload2">导出</el-button> -->
        <el-button type="primary" icon="el-icon-plus" @click="addPoints">新增</el-button>
      </div>
    </div>
    <div class="user_list">
      <el-table :data="userList" style="width: 100%" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="email" label="账号"></el-table-column>
        <el-table-column prop="role" label="角色">
          <template slot-scope="scope">
            <span>{{scope.row.role.title}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button v-if="scope.row.id!==1" type="text" size="small" @click="editbox(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.id!==1" @click="removesize(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 新增--编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up" @close="cancelform">
      <el-form :model="Edform" :rules="rules" label-width="100px">
        <el-form-item label="名称">
          <el-input v-model="Edform.name"></el-input>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="Edform.email"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-if="titleName=='新增'">
          <el-input v-model="Edform.password" show-password></el-input>
        </el-form-item>
        <el-form-item label="密码" v-if="titleName=='编辑'">
          <el-input v-model="Edform.password" show-password placeholder="如需要修改密码则输入内容，如不修改则留空"></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="Edform.role_id" placeholder="请选择角色">
            <el-option v-for="item in roledatas" :key="item.role_id" :label="item.title" :value="item.role_id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelform">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  adminroles,
  adminlists,
  adminadd,
  admindelete,
  adminedit
} from "../../api/system.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userform: {
        role_id: ""
      },
      Edform: {
        role_id: "",
        password: "",
        email: "",
        name: ""
      },
      userList: [
        {
          name: "9f30002",
          num: "1000",
          role: {
            title: ""
          }
        }
      ],
      roledatas: [],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      rules: {
        reason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }]
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //角色列表 rolelists
    roledata() {
      let data = {};
      adminroles(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.roledatas = res.data;
        }
      });
    },
    //后台用户列表
    adminlists() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        role_id: this.userform.role_id
      };
      adminlists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.userList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.adminlists();
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
      this.currentindex = 1;
      this.adminlists();
    },
    //取消搜索
    nosub() {
      this.userform.role_id = "";
      this.currentindex = 1;
      this.adminlists();
    },
    // 新增--弹窗
    addPoints() {
      this.titleName = "新增";
      this.pop_up = true;
    },
    //编辑弹窗
    editbox(e) {
      this.titleName = "编辑";
      // console.log(e);
      this.Edform.id = e.id;
      this.Edform.email = e.email;
      this.Edform.password = e.password;
      this.Edform.name = e.name;
      this.Edform.role_id = e.role_id;
      this.pop_up = true;
    },
    //弹窗取消
    cancelform() {
      this.pop_up = false;
      this.Edform.id = "";
      this.Edform.email = "";
      this.Edform.password = "";
      this.Edform.name = "";
      this.Edform.role_id = "";
    },
    //弹窗提交
    SubmitAdd() {
      // console.log(this.Edform);
      if (this.titleName == "新增") {
        // adminadd
        if (this.Edform.email == "") {
          this.$message({
            type: "warning",
            message: "请将信息填写完整!"
          });
        } else if (this.Edform.password == "") {
          this.$message({
            type: "warning",
            message: "请将信息填写完整!"
          });
        } else if (this.Edform.name == "") {
          this.$message({
            type: "warning",
            message: "请将信息填写完整!"
          });
        } else if (this.Edform.role_id == "") {
          this.$message({
            type: "warning",
            message: "请将信息填写完整!"
          });
        } else {
          let data = {
            email: this.Edform.email,
            password: this.Edform.password,
            name: this.Edform.name,
            role_id: this.Edform.role_id
          };
          adminadd(data).then(res => {
            if (res.status_code == 200) {
              this.cancelform();
              this.currentindex = 1;
              this.adminlists();
              this.$message({
                type: "success",
                message: "添加成功!"
              });
            }
          });
        }
      }
      if (this.titleName == "编辑") {
        // adminedit
        let data = {
          id: this.Edform.id,
          email: this.Edform.email,
          password: this.Edform.password,
          name: this.Edform.name,
          role_id: this.Edform.role_id
        };
        adminedit(data).then(res => {
          if (res.status_code == 200) {
            this.cancelform();
            this.currentindex = 1;
            this.adminlists();
            this.$message({
              type: "success",
              message: "编辑成功!"
            });
          }
        });
      }
    },
    //选中
    handleSelectionChange(val) {
      // console.log(val);
    },
    //删除 admindelete
    removesize(e) {
      // console.log(e);
      let data = {
        id: e.id
      };
      admindelete(data).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.adminlists();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.roledata();
    this.adminlists();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.staff {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    .btn_box {
      margin-left: 20px;
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.staff {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
</style>